import React, { Component } from 'react';

class IconChevron extends Component {
    render() {
        return (
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
              <title>Chevron</title>
              <g id="icon-/-chevron" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <path d="M17.2878592,21.3087774 L15.8425755,22.6912226 L6.27735814,12.6912226 C5.90754729,12.3046022 5.90754729,11.6953978 6.27735814,11.3087774 L15.8425755,1.30877735 L17.2878592,2.69122265 L8.38381134,12 L17.2878592,21.3087774 Z" id="Stroke-1" fill="#000000"/>
              </g>
          </svg>
        )
    }
}

export default IconChevron;